export default {
  'component.metalisting.title': 'Meta informasjon',
  'component.metalisting.tablesearch': 'Søk av side navn, tittel',
  'component.metalisting.uploadimage': 'Last opp bilde',
  'component.metalisting.keywords': 'Nøkkelord',
  'component.metalisting.editmetalisting': 'Metum Edit',
};
